import { create } from 'zustand'

const useCustomOrderStore = create((set) => ({
  pendingCODialog: null,
  setPendingCODialog: (data) => set({ pendingCODialog: data }),
  invoice_data: {},
  setInvoiceData: (data) => set({ invoice_data: data }),
}))

export default useCustomOrderStore;